import axios from "axios";

import { APIConfig, ModifiedAxios } from '@growmark/axios/types';
import withConfig from "@growmark/axios/core";
import { bearer, versioned } from '@growmark/axios/config';
import { cognito } from "@growmark/axios/authn/cognito";
import instance from '@growmark/cognito-vue';
import { GROWER } from '@growmark/gcmp-api/types';

axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.timeout = 30 * 60 * 1000;

//auth
const authz = bearer(cognito(instance), { header: 'Authorization' });

//used config
export { versioned, authz };

export const useRegistrationAPI = (config: APIConfig) : ModifiedAxios<GROWER.ENDPOINTS> => {
	const axiosConfig = {
		baseURL: `${process.env.VUE_APP_SERVICE_API_URL}/${process.env.VUE_APP_SERVICE_API_VER}`,
		timeout: 30 * 1000
	};
	const myAxios = axios.create(axiosConfig);
	return withConfig<GROWER.ENDPOINTS>(config)(myAxios);
};

export default useRegistrationAPI;